import React, { useState, useEffect } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import { Grid } from "@material-ui/core";
import { Spinner, Card, Typography, Input, IconButton, Tooltip, Dialog, DialogHeader, DialogBody, DialogFooter, Button, Select, Option, Tabs, TabsHeader, TabsBody, Tab, TabPanel, Textarea } from '@material-tailwind/react';
import { MagnifyingGlassIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import ExportToExcelGeneric from '../componentes/exportExcelGeneric';
import { PiePagina, Paginacion, usePaginacion } from '../Helpers/importacionesComunes'

const ITipoIglesiaModel = {
    id_tipo_iglesia: null,
    nombre: ''
}


export default function TipoIglesias({ usuario }) {

    const [tipoIglesiasList, setTipoIglesiasList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [nameSearch, setNameSearch] = useState('')
    const [tipoIglesiaId, setTipoIglesiaId] = useState(0)
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [open, setOpen] = React.useState(false);
    const [tipoIglesiasData, setTipoIglesiasData] = useState(ITipoIglesiaModel);
    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion()

    useEffect(() => {
        obtenerArchivos()
    }, [])

    const obtenerArchivos = async () => {
        setBuscandoDatos(true);
        try {
            const resultList = await Promise.all([Axios.get(`/api/tablasgenerales/tiposiglesias`)])
            setTipoIglesiasList(resultList[0].data)
            setFilteredList(resultList[0].data)
            setBuscandoDatos(false);
            inicializarPaginacion(null, resultList[0].data)
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const handleOpen = () => { 
        setOpen(!open);
    }

    const verTipoIglesia = async (e) => {
        try {
            setTipoIglesiaId(e.id_tipo_iglesia);

            let data = {
                id_tipo_iglesia: e.id_tipo_iglesia,
                orden: e.orden,
                nombre: e.nombre
            }
            setTipoIglesiasData(data)

            handleOpen();
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const verCrearTipoIglesia = async (e) => {
        try {
            setTipoIglesiaId(0);
            handleOpen();
            setTipoIglesiasData(ITipoIglesiaModel);
        } catch (error) {
            console.log(error)
            setBuscandoDatos(false);
        }
    }

    const crearTipoIglesia = async () => {
        try {
            await Promise.all([Axios.post(`/api/tablasgenerales/tiposiglesias/`, tipoIglesiasData)])
            Swal.fire({
                icon: 'alert',
                title: `<p>El tipo de iglesia ha sido creada con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al crear los Datos. Verifique los datos del formulario</p>`,
                showCancelButton: true,
            })
            console.log(error)
            setOpen(true);
        }
    }

    const editarTipoIglesia = async () => {
        try {
            const data = {
                ...tipoIglesiasData,
                id_tipo_iglesia: tipoIglesiaId
            }
            await Promise.all([Axios.post(`/api/tablasgenerales/tiposiglesias`, data)])
            Swal.fire({
                icon: 'alert',
                title: `<p>Los datos han sido actualizados con éxito</p>`,
            })
            handleOpen();
            obtenerArchivos();
            setTipoIglesiasData(ITipoIglesiaModel);
            setTipoIglesiaId(0);
        } catch (error) {
            Swal.fire({
                icon: 'alert',
                title: `<p>Error al actualizar los Datos</p>`,
                showCancelButton: true,
            })
            console.log(error)
            setOpen(true);
        }
    }

    const borrarTipoIglesia = async (e) => {
        Swal.fire({
            title: "Esta seguro que desea Eliminarlo?",
            text: "Este cambio es irreversible!",
            type: "warning",
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: "No, cancelar!",
            showCancelButton: true,
            // allowOutsideClick: false
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Promise.all([Axios.delete(`/api/tablasgenerales/tiposiglesias/${e.id_tipo_iglesia}`)])
                        obtenerArchivos();
                        setNameSearch('');
                    } catch (error) {
                        console.log(error)
                        setBuscandoDatos(false);
                    }
                }
            }
        )
    }

    const limpiarBusqueda = async () => {
        obtenerArchivos();
        setNameSearch('')
    }

    const prepareExcelData = () => {
        return tipoIglesiasList.map(item => ({ Nombre: item.nombre }))
    }

    const handleSearchData = async () => {
          if (nameSearch.trim() === '') {
            setFilteredList(tipoIglesiasList);
        } else {
            const listaFiltrada = tipoIglesiasList.filter(item =>
                item.nombre.toLowerCase().includes(nameSearch.toLowerCase())
            );
            setFilteredList(listaFiltrada.length > 0 ? listaFiltrada : tipoIglesiasList);
        }
    }

    if (buscandoDatos) {
        return <Main center alinear>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando archivos...</span>
            </div>
        </Main>
    }

    if (tipoIglesiasList.length == 0) {
        return <Grid container justifyContent='center' alignItems='center' style={{ minHeight: '400px', textAlign: 'center' }} >
            <Grid item>
                <Typography variant="h5">
                    No se encontraron archivos
                </Typography>
            </Grid>
        </Grid>
    }

    return <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
        <Typography variant="h4" className="flex ">
            Tipo de Iglesias
        </Typography>
        <Card className='w-full justify-center items-center flex p-5 justify-left mt-4'>
              <div className='w-full lg:w-96 xl:w-96 relative'>
                                        <Input
                                            type="text"
                                            label="Buscar"
                                            value={nameSearch}
                                            onChange={(e) => { setNameSearch(e.target.value) }}
                                            color='black'
                                        />
                                        <Button
                                            size="sm"
                                            color={nameSearch ? "blue" : "blue-gray"}
                                            disabled={!nameSearch}
                                            className="!absolute right-1 top-1 rounded flex"
                                            onClick={handleSearchData}
                                        >
                                            <MagnifyingGlassIcon className="h-4 w-4 mr-2" />Buscar
                                        </Button>
                                </div>
            {tipoIglesiasList.length > 0 && <div className='mt-8 w-full'>
                <div className="flex flex-col md:flex-row gap-2 xl:!justify-end">
                    <Button className="flex ml-2 justify-center gap-3 bg-green-500" onClick={verCrearTipoIglesia}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="h-4 w-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                        Crear
                    </Button>
                <Button variant='text' className='text-red-400 bg-red-100 hover:bg-red-200 ml-2' onClick={limpiarBusqueda}>Limpiar Busqueda</Button>
                    <ExportToExcelGeneric data={prepareExcelData()} fileName="Listado de Tipo de Iglesias" isProvider={true}/>
                </div>
                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal leading-none"
                                >
                                    Se han encontrado {tipoIglesiasList.length} Tipo de Iglesias
                                </Typography>
                {tipoIglesiasList.length > 0 &&
                    <PiePagina>
                        <div className="">
                            <Paginacion configuracion={configuracion} paginar={paginar} />
                        </div>
                    </PiePagina>}
                <table className="text-left w-full mt-2">
                    <thead>
                        <tr>
                            <th
                                className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                            >
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal leading-none opacity-70"
                                >
                                    Nombre
                                </Typography>
                            </th>
                            <th
                                className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                            >
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal leading-none opacity-70"
                                >
                                    Acciones
                                </Typography>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.filter((item, index) => {
                                return index >= configuracion.iIni && index <= configuracion.iFin
                            }).map((item, index) => {
                            const isLast = index === filteredList.length - 1;
                            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                            return (
                                <tr key={index}>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {item.nombre}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <div className="flex items-center gap-2">
                                            <Tooltip content="Ver Detalles">
                                                <IconButton variant="text" size="sm" onClick={() => verTipoIglesia(item)}>
                                                    <PencilIcon className="h-4 w-4 text-gray-900" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip content="Eliminar">
                                                <IconButton variant="text" size="sm" onClick={() => borrarTipoIglesia(item)}>
                                                    <TrashIcon className="h-4 w-4 text-gray-900" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {filteredList.length > 0 &&
                    <PiePagina>
                        <div className="">
                            <Paginacion configuracion={configuracion} paginar={paginar} />
                        </div>
                    </PiePagina>}
            </div>}
        </Card>
        <Dialog open={open} handler={handleOpen}>
            <DialogHeader>{tipoIglesiaId !== 0 ? 'Editar' : 'Crear'} Tipo Iglesia</DialogHeader>
            <DialogBody className="xl:p-10">

                <Tabs value="Contacto" className="max-w-full mt-2">
                    <TabsBody>

                        <div className="flex flex-col w-full mt-4">
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="mb-1 font-medium "
                            >
                                Nombre
                            </Typography>
                            <Input
                                onChange={(e) => {
                                    setTipoIglesiasData({...tipoIglesiasData, nombre: e.target.value})
                                }}
                                value={tipoIglesiasData.nombre}
                                type='text'
                                id='name'
                                name='name'
                                color='black'
                                className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                                labelProps={{
                                    className: "before:content-none after:content-none",
                                }}
                            />
                        </div>

                        <div className="flex flex-col w-full mt-4">
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="mb-1 font-medium "
                            >
                                Orden
                            </Typography>
                            <Input
                                onChange={(e) => {
                                    setTipoIglesiasData({...tipoIglesiasData, orden: e.target.value})
                                }}
                                value={tipoIglesiasData.orden}
                                type='number'
                                id='orden'
                                name='orden'
                                color='black'
                                className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                                labelProps={{
                                    className: "before:content-none after:content-none",
                                }}
                            />
                        </div>
                    </TabsBody>
                </Tabs>
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button 
                    variant="gradient" 
                    color="blue" 
                    onClick={() => tipoIglesiaId !== 0 ? editarTipoIglesia() : crearTipoIglesia()}
                >
                    Guardar
                </Button>
                <Button variant="text" color="blue-gray" onClick={handleOpen}>
                    Cancelar
                </Button>
            </DialogFooter>
        </Dialog>
    </div>
}

